import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { certificateAPI } from '../../services/api';
import { LoadingSpinner, EmptyState } from '../../components/UI';

const TrainerCertificates = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await certificateAPI.trainerIssued();
        setCerts(data);
      } catch (e) {
        toast.error('Failed to load');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleDownload = async (cert) => {
    setDownloadingId(cert._id);
    try {
      const response = await certificateAPI.download(cert._id);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `certificate-${cert.certificateId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error('Download failed');
    } finally {
      setDownloadingId(null);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1 style={{ color: 'var(--green)' }}>Certificates Issued</h1>
          <p className="subtitle">{certs.length} total</p>
        </div>
      </div>

      {certs.length === 0 ? (
        <EmptyState icon="🏆" title="No certificates issued" message="Issue certificates from the Students page" />
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Certificate ID</th>
                <th>Student</th>
                <th>Course</th>
                <th>Grade</th>
                <th>Score</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {certs.map((c) => (
                <tr key={c._id}>
                  <td><code style={{ fontSize: '0.78rem' }}>{c.certificateId}</code></td>
                  <td>{c.user?.name}</td>
                  <td>{c.course?.title}</td>
                  <td><strong>{c.grade}</strong></td>
                  <td>{c.score}%</td>
                  <td>{new Date(c.issuedAt).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => handleDownload(c)}
                      disabled={downloadingId === c._id}
                    >
                      {downloadingId === c._id ? '…' : '⬇ PDF'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TrainerCertificates;
